import classes from './ProductPage.module.css';
import image from '../../../Designs/1.jpg';
import shoppingcart from '../../../Designs/shoppingcart.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useEffect, useState} from 'react';
import {styled} from '@mui/material/styles';
import FavoriteTwoToneIcon from '@mui/icons-material/FavoriteTwoTone';
import {connect} from 'react-redux';
import globalActions from '../../../Redux/actions/global';

const mapStateToProps = state => ({
  cart: JSON.parse(localStorage.getItem("cart")) || state.changeCart,
});

const mapDispatchToProps = dispatch => ({
  addToCart: (item, quantity) => dispatch(globalActions.addToCart(item, quantity)),
  updateCart: (item, quantity) => dispatch(globalActions.updateCart(item, quantity)),
})

const ProductPage = ({addToCart,
                      updateCart,
                      cart,
                      title,
                      price,
                      category,
                      subcategory,
                      description}) => {
  useEffect(() => {
    window.scrollTo(0,0);
  }, []);

  const Arrow = styled(ExpandMoreIcon)(({theme}) => ({
    fontSize: "16px",
    color: "black",
  }));

  const [cartbgcolor, setCartBgColor] = useState(false);
  const [quantitycolor, setQuantitiyColor] = useState([false, false]);
  const [quantity, setQuantity] = useState(1);
  const [wishcolor, setWishColor] = useState(false);

  const WishIcon = styled(FavoriteTwoToneIcon)(()=>({
    '& path:first-of-type': {
      color: wishcolor ? 'black' : 'white',
      opacity: 1,
    },
    '& path:last-child': {
      color: 'black',
    }
  }));

  return (
    <>
      <div className={`outer ${classes.container} `}>
        <div className={classes.navigation}>
          <h3>Tienda</h3>
          <h5>Nav/Nav</h5>
        </div>
        <div className={classes.leftImages}>
          <img src={image}/>
          <img src={image}/>
          <img src={image}/>
        </div>
        <img src={image}/>
        <div className={classes.productTitle}>
          <h1>{title}</h1>
          <p>{`S/${price}`}</p>
        </div>
        <div className={classes.productDescription}>
          <p>{description}</p>
        </div>
        <span className={classes.category}>
          Categoria: <p>{`${category} & ${subcategory}`}</p>
        </span>
        <h4 className={classes.tag}>
          Tags: <p>tags</p>
        </h4>
        <div className={classes.cartAdder}>
          <div>
            <p>{quantity}</p>
            <div>
              <div onClick={()=>{setQuantity(quantity+1)}}>
                <Arrow sx={{
                    transform: "rotate(180deg)",
                  }}/>
              </div>
              <div onClick={()=>{
                  if (quantity>1) {
                      setQuantity(quantity-1)}
                  }}>
                <Arrow/>
              </div>
            </div>
          </div>
          <div onMouseOver={()=>{setCartBgColor(true)}}
            onClick={()=>{
              const foundItem = cart.map(list =>
                Array.isArray(list) ?
                list.filter(({item, quantity}) => item===title)
                : null)[0];
              if (foundItem.length) {
                updateCart(title, quantity);
              } else {
                addToCart(title, quantity);
              }
            }}
            onMouseOut={()=>{setCartBgColor(false)}}>
            <span/>
            <p>ADD TO CART</p>
            <div className={`${cartbgcolor ? 'changeBackgroundColor' : ''}`}>
              <img src={shoppingcart}/>
            </div>
          </div>
        </div>
        <div onClick={()=>{
            if (wishcolor) {
              setWishColor(false);
            } else {
              setWishColor(true);
            }
          }}>
          <WishIcon/>
          <h5>{
              wishcolor ?
              "Added to wishlist!" : "Add to wishlist"
            }</h5>
          <span/>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
